

if(window.innerWidth < 768){

    $(".chris-des.mobShow .readmoreDesc").click(function(){
        let mainParentDesc = $(this).closest(".chris-container")
        mainParentDesc.find(".chris-des .lessDesc").hide();
        mainParentDesc.find(".chris-des .allDescription").show();
        mainParentDesc.find('.chris-des.mobShow').addClass('active');
        mainParentDesc.find(".chris-des .readlessDesc")[0].focus();
      });
    
     $(".chris-des.mobShow .readlessDesc").click(function(){
      let mainParentDesc = $(this).closest(".chris-container")
      mainParentDesc.find(".chris-des .allDescription").hide();
      mainParentDesc.find(".chris-des .lessDesc").show();
      mainParentDesc.find('.chris-des.mobShow').removeClass('active');
      mainParentDesc.find(".chris-des .readmoreDesc")[0].focus();
      });
    

}

